var TscButtonContentType = {
  text: 'text',
  glyph: 'glyph',
  mixed: 'mixed'
};
export default TscButtonContentType;